<template>
    <BaseForm>
        <template #title>Выберите условия займа и введите номер телефона</template>
        <Conditions v-if="$vuetify.breakpoint.lgAndUp"/>
        <v-row>
            <Field v-for="name in [
                'initialPayment',
                'term', 
                ]"
                :key="name"
                :anketaName="name"
                />
        </v-row>
        <v-form ref="form">
            <v-row>
                <Field anketaName="phone" />
                <v-col cols="6" class="text-right pt-2">
                    <Button 
                        class="mt-10" 
                        @click="next"
                        >
                        Получить
                    </Button>
                </v-col>
            </v-row>
        </v-form>
    </BaseForm>
</template>

<script>
import Conditions from "../controls/Conditions.vue"
export default {
    components: {
        Conditions,
    },
    methods: {
        next() {
            console.log(this.$refs.form.validate())
            if (this.$refs.form.validate()) {
                this.$connector.CreateApplication().then(
                    data => {
                        this.$anketa.onlineToken = data.onlineToken;

                        this.$connector.SendJuicyData();
                    }
                );
                this.$forms.open('Passport');
            }
        }
    }

}
</script>

